<ah-attachement [uploadedAttachments]="attachments" [isView]="(attachments.length > 0)" (emitAction)="uploadedAsset($event)"></ah-attachement>
